export default function GoogleMapsWidget() {
  return (
    <div className="flex container mx-auto">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4754.164167358877!2d-113.47953315483498!3d53.43124059451188!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53a01fd489974c83%3A0xfa6251307d0516e5!2sFamily%20Health%20Medical%20Centre!5e0!3m2!1sen!2sca!4v1773769231856!5m2!1sen!2sca"
        width="600"
        height="450"
        style={{ border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
